import * as log from 'loglevel'

export const LogLevel = log.levels

export const UnitLog = log.getLogger('athlinks-results-client/units')

UnitLog.setDefaultLevel(LogLevel.INFO)

export function setUnitLogLevel(logLevel: log.LogLevelDesc) {
  UnitLog.setLevel(logLevel)
}